/**
 * Ordering - form exports and hardcoded slug.
 * Registration is handled centrally in content-prompt/src/index.ts.
 */

export const ORDERING_SLUG = 'ordering';

export { OrderingForm } from './OrderingForm';
export type { OrderingMediaType, OrderingSourceType, OrderingFormState } from './types';
export { MEDIA_OPTIONS, MIN_ITEMS, MAX_ITEMS, DEFAULT_FORM_STATE } from './types';
export { QUESTION_TYPE_PRESETS, QUICK_CREATE_TEMPLATES } from './config';
export type { QuickCreateTemplate } from './config';
